<template>
  <div class="common-label flex items-center justify-center">
    <div class="text-center w-full">
      <div class="aisea-text-14-600-dark-gray mb-2" v-show="showTitle">
        {{ title }}
      </div>
      <!-- contents -->
      <div>
        <slot name="contents"></slot>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "M.CommonLabel",
  props: {
    title: {
      type: String,
      required: false
    },
  },
  computed: {
    showTitle() {
      return this.title && this.title.length > 0;
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.common-label {
  width: 100%;
  background-color: $aisea-pure-white;
  border-radius: 6px;
  padding: 16px;
}
</style>